import type React from 'react'

import { TextAligning } from 'atoms/TextBox'
import { TextBoxFontXs, TextBoxMaxLine1FontXl } from 'atoms/TextBox/Templates'
import {
  AudioAutoQualityBodySC,
  AudioAutoQualitySC,
} from './AudioAutoQuality.styled'

export interface IAudioAutoQuality {
  title: string
  description: string
  children: React.ReactNode
}

export const AudioAutoQuality = ({
  title,
  description,
  children,
}: IAudioAutoQuality) => {
  return (
    <AudioAutoQualitySC>
      <TextBoxMaxLine1FontXl title={title} />

      <AudioAutoQualityBodySC>{children}</AudioAutoQualityBodySC>

      <TextBoxFontXs title={description} alignment={TextAligning.Left} />
    </AudioAutoQualitySC>
  )
}
